import SwitchEnvironment from "ce/components/SwitchEnvironment";
export default SwitchEnvironment;
